<script lang="ts">
	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';
	import WeatherStationCard from './WeatherStationCard.svelte';
	import DropletPercentLight from './Icons/DropletPercentLight.svelte';

	export let statuses;

	$: humidity = statuses.find((i) => i.name === 'humidity:0');
	$: dewpoint = statuses.find((i) => i.name === 'dewpoint:0');
</script>

<WeatherStationCard
	on:click
	icon="fas fa-droplet-percent"
	label={capFirstChar($format('title_chart_humidity', { default: 'Humidity' }))}
	value={humidity?.value}
	description={$format('label_dewpoint', {
		default: 'Dewpoint',
	})}
	descriptionValue={dewpoint?.value}
>
	<div slot="main" class="d-flex">
		<DropletPercentLight />
	</div>
</WeatherStationCard>
